<div *ngIf="showPicker">
    <cs-file-uploader [uploadType]="uploadType" [contextId]="contextId" [uploadStatus]="uploadStatus"
        [importBehaviors]="importBehaviors" [uploadButtonEnabled]="isUploadButtonEnabled()" [userId]="userId"
        (changeUploadId)="changeUploadId($event)" [header]="header" [popoverContent]="popoverContent">
    </cs-file-uploader>
    <cs-file-uploader-progress [uploadId]="uploadId" [uploadStatus]="uploadStatus"
        (changeUploadStatus)="changeUploadStatus($event)" (onImportComplete)="handleImportComplete()">
    </cs-file-uploader-progress>
</div>